import { render } from "./VoipService.vue?vue&type=template&id=a8bb5256"
import script from "./VoipService.vue?vue&type=script&lang=js"
export * from "./VoipService.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "a8bb5256"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8bb5256', script)) {
    api.reload('a8bb5256', script)
  }
  
  module.hot.accept("./VoipService.vue?vue&type=template&id=a8bb5256", () => {
    api.rerender('a8bb5256', render)
  })

}

script.__file = "src/views/services/modules/voip/VoipService.vue"

export default script